export const SET_CURRENT_MUNICIPALITY = "municipality/set_current_municipality"
export const SET_CURRENT_WARD = "municipality/set_current_ward"
export const SET_WARD_PROFILE = "municipality/set_ward_profile"
export const SET_MUNICIPALITY = "municipality/set_municipality"
